import Radio from 'backbone.radio';
import ChangeEmailDialog from '@/views/dialogs/change_email';
import ConfirmEmailDialog from '@/views/dialogs/confirm_email';

    var globalCh = Radio.channel('global');
    function show_change_email_dialog(account, token) {
        // TODO: Make it use active account if account not passed
        if (token) {
            // Show the second stage of changing email, i.e. confirming email was received
            globalCh.request('showDialog', new ConfirmEmailDialog({
                model: account,
                token: token,
            }));
        } else {
            // Show the first stage of changing email, i.e. sending a PATCH to request a token
            globalCh.request('showDialog', new ChangeEmailDialog({
                model: account
            }));
        }
    }
    export default show_change_email_dialog;

